export const SEARCH_FIELD_DEFAULTS = {
  uam_id: "",
  phone: "",
  admission_number: "",
};

export const resetSearchFields = (setFieldValue) => {
  Object.entries(SEARCH_FIELD_DEFAULTS).forEach(([field, val]) =>
    setFieldValue(field, val),
  );
};
